import { ref } from "vue";
import { defineStore } from "pinia";
import { showToast } from "vant";
import { getTerminalUrl } from "@/api";
import websocketUrl from "@/api/websocket";
import initWebSocket from "@/utils/websocket";
interface terminalUrlListType {
  indexCode: string;
  systemName: string;
  jumpUrl: string;
  updateTime: string;
}
export const appConfigStore = defineStore("appconfig", () => {
  const usersSocketUrl = ref(initWebSocket(websocketUrl.cradle_head));
  const terminalUrlList = ref<terminalUrlListType[]>([]);
  const priviewImgPasteBaseUrl = ref("");

  const init = async () => {
    try {
      if (import.meta.env.VITE_APP_ENV == "development") {
        priviewImgPasteBaseUrl.value = import.meta.env.VITE_APP_BASE_API;
      } else if (import.meta.env.VITE_APP_ENV == "staging") {
        priviewImgPasteBaseUrl.value = window.location.origin + import.meta.env.VITE_APP_BASE_API;
      } else {
        priviewImgPasteBaseUrl.value = window.location.origin + import.meta.env.VITE_APP_BASE_API;
      }

      const res = await getTerminalUrl();
      if (res && res.code == 200) {
        // console.log(res);
        terminalUrlList.value = res.data;
      } else {
        showToast("获取终端地址失败");
      }
    } catch (err) {
      console.log(err);
    }
  };
  return {
    init,
    usersSocketUrl,
    terminalUrlList,
    priviewImgPasteBaseUrl
  };
});
